import apiClient from "./ApiService";
import { PATH_GET_MANAGER_BY_ID_TRANSACTION, PATH_GET_MANAGER_BY_ID_TRANSACTION_AND_OTP_VALID } from "../config/env";

export const getManagerByTransaction = async(id)=>{
    return await apiClient.get(PATH_GET_MANAGER_BY_ID_TRANSACTION+id);
}

export const getUserInfoByTransactionAndOTPValid = async(id)=>{
    return await apiClient.get(PATH_GET_MANAGER_BY_ID_TRANSACTION_AND_OTP_VALID+id);
}